import { chevronLeftIcon, closeIcon } from '@justgiving/icons';
import SVG from '@justgiving/svg';
import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '../IconButton/IconButton';
import IsLargeScreen from '../IsLargeScreen/IsLargeScreen';
import IsSmallOrMediumScreen from '../IsSmallOrMediumScreen/IsSmallOrMediumScreen';
import styles from './SettingsModal.scss';

interface SettingsModalProps {
  title: string;
  onCloseRequest: () => void;
  'aria-label'?: string;
}

const SettingsModal: React.FunctionComponent<SettingsModalProps> = ({
  title,
  onCloseRequest,
  children,
  'aria-label': ariaLabel,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <div aria-label={ariaLabel} className={styles.modal}>
      <IsSmallOrMediumScreen>
        <header className="jg-display-flex jg-flex-ais jg-space-prmd">
          <IconButton
            onClick={onCloseRequest}
            aria-label={t('modal.backButton')}
          >
            <SVG markup={chevronLeftIcon} className={styles.icon} />
          </IconButton>
          <span className={styles.title}>{title}</span>
        </header>
      </IsSmallOrMediumScreen>
      <IsLargeScreen>
        <header className="jg-display-flex jg-flex-column jg-flex-asc">
          <IconButton
            onClick={onCloseRequest}
            className={styles.closeButton}
            aria-label={t('modal.closeButton')}
          >
            <SVG
              markup={closeIcon}
              className={cn(styles.icon, 'jg-flex-ase')}
            />
          </IconButton>
          <span className={cn(styles.title, 'jg-flex-asc')}>{title}</span>
        </header>
      </IsLargeScreen>
      <div className={styles.scrollBody}>{children}</div>
    </div>
  );
};

export default SettingsModal;
